/* eslint-disable @typescript-eslint/no-empty-object-type */
import { createElement } from "react";

import type { ComponentType, FC, PropsWithChildren } from "react";

type InferConnectHoc<InferredProps> = <OwnProps>(
	component: ComponentType<OwnProps & InferredProps>,
) => FC<PropsWithChildren<OwnProps>>;

/**
 * Create a high-order-component (HoC) which injects props like react-redux connect, can also be used for injecting hook return values into class component.
 * @deprecated You should just use hooks and function components directly.
 */
export const createConnectHoc = <TOwnProps extends {}, TConnectProps extends {}>(connect: () => TConnectProps) =>
	((component: ComponentType<TOwnProps & TConnectProps>): FC<PropsWithChildren<TOwnProps>> => {
		const ConnectedComponent: FC<TOwnProps> = ownProps => {
			const connectProps = connect();

			return createElement<TOwnProps & TConnectProps>(component, { ...ownProps, ...connectProps });
		};

		return ConnectedComponent;
	}) as unknown as InferConnectHoc<TConnectProps>;
